export default __webpack_public_path__ + "static/media/Group 190.d1dd347d.svg";